module.exports = __webpack_public_path__ + "static/img/_F5T3862-900px.0d3de11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_F5T3862-900px.jpg
// module id = WZ+i
// module chunks = 0